"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FlagDismiss = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M17.5,5 C17.5776225,5 17.6541791,5.01807255 17.7236068,5.0527864 C17.970596,5.17628103 18.0707082,5.47661755 17.9472136,5.7236068 L16.059017,9.5 L17.309,12 L16.19,12 L14.940983,9.5 L16.690983,6 L7,6 L7,13 L11,12.999 L11,14 L7,14 L7,20 L6,20 L6,5 L17.5,5 Z M13.7843055,13.0885912 L13.8535534,13.1464466 L16.5,15.793 L19.1464466,13.1464466 C19.3417088,12.9511845 19.6582912,12.9511845 19.8535534,13.1464466 C20.0271197,13.320013 20.0464049,13.5894374 19.9114088,13.7843055 L19.8535534,13.8535534 L17.207,16.5 L19.8535534,19.1464466 C20.0488155,19.3417088 20.0488155,19.6582912 19.8535534,19.8535534 C19.679987,20.0271197 19.4105626,20.0464049 19.2156945,19.9114088 L19.1464466,19.8535534 L16.5,17.207 L13.8535534,19.8535534 C13.6582912,20.0488155 13.3417088,20.0488155 13.1464466,19.8535534 C12.9728803,19.679987 12.9535951,19.4105626 13.0885912,19.2156945 L13.1464466,19.1464466 L15.793,16.5 L13.1464466,13.8535534 C12.9511845,13.6582912 12.9511845,13.3417088 13.1464466,13.1464466 C13.320013,12.9728803 13.5894374,12.9535951 13.7843055,13.0885912 Z" })));
};
FlagDismiss.displayName = 'FlagDismiss';
exports.default = FlagDismiss;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FlagDismiss.js.map